"use strict";
// El import dinámico es el patrón requerido por Module Federation para evitar
// "eager consumption" de singletons compartidos. Si el chunk falla (Safari cachea
// versión obsoleta tras un deploy), forzamos recarga para obtener los nuevos bundles.
import('./bootstrap').catch(() => {
    window.location.reload();
});
